import styled from 'styled-components'
import { Progress } from 'antd'
import { greys } from 'assets/themes/theme-default'

const AntProgresstyled = styled(Progress)`
  &&& {
    .ant-progress-inner {
      background-color: ${greys.light3};
    }

    .ant-progress-bg {
      background-color: ${props => props.theme.colors.color1.bg};
    }
  }
`

export default AntProgresstyled
